<div class="container">
  @if(isLoadingDashboardData && isLoadingAemContent) {
  <div class="row justify-content-center align-items-center spinner-style">
    <div class="col-12 text-center">
      <h2 class="mb-4">Loading your Dashboard...</h2>
      <div class="spinner-border text-primary spinner-style-text" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
  }
  <div
    class="dashboard-container"
    [hidden]="isLoadingDashboardData && isLoadingAemContent"
  >
    <!-- Notification Banner Section -->
    @if(showNotificationBanner){
    <section>
      <!-- Notification Banner -->
      <div class="notification-banner">
        <div class="notification-content">
          <div
            class="gb-headline6 heavy text-white pb-12-16"
            [innerHTML]="$safeNavigationMigration(aemContent?.notificationTitle1) | safeHtml"
          ></div>
          <div class="gb-body2 text-white">
            {{aemContent?.notificationSubTitle4}}
          </div>
        </div>
      </div>
    </section>
    }

    <!-- Welcome Section, Card, Points Section and Offer Section -->
    <section
      [ngClass]="showNotificationBanner ? 'p-64 p-48' : 'pt-0-64 pt-0-48'"
    >
      <!-- Welcome Section -->
      <div class="welcome-section gb-headline1 heavy">
        <div>
          {{aemContent?.welcomeTitle1}}<span class="user-name"
            >{{userName}}</span
          >
        </div>
      </div>

      <!-- Card and Points Section -->
      <div class="row card-points-section">
        <!-- Card Info -->
        <div class="col-md-12">
          <div class="card card-info">
            <div class="card-content d-flex flex-column flex-md-row">
              <div class="d-flex flex-column flex-md-row flex-grow-1">
                <div class="d-flex flex-column card-image-container">
                  <img
                    [src]="cardImageUrl"
                    alt="GM Business Card"
                    class="img-fluid"
                  />
                </div>
                <div class="d-flex flex-column card-details">
                  <div
                    class="d-flex flex-row flex-shrink-1 card-header-text gb-headline4 heavy"
                  >
                    <div
                      [innerHTML]="$safeNavigationMigration(aemContent?.cardTypeTitle6) +' - '+  cardNumber | safeHtml"
                    ></div>
                  </div>
                  <!-- Mobile view -->
                  <div class="card-details d-block d-md-none">
                    <div
                      class="total-points-label gb-headline5 heavy"
                      [innerHTML]="$safeNavigationMigration(aemContent?.totalPointsTitle2) | safeHtml"
                    ></div>
                    <div class="total-points-value gb-headline1 heavy">
                      {{totalEarnings | number:'1.0-0'}}
                    </div>
                    <div class="points-date gb-body1 heavy">
                      {{aemContent?.dateSubTitle1}}{{asOf}}
                    </div>
                  </div>
                  <div
                    class="total-points-label d-flex justify-content-center justify-content-md-start flex-shrink-1"
                  >
                    <button
                      (click)="openModal('manageCard')"
                      class="btn btn-outline-dark btn-style gb-headline4 heavy stat-button-link"
                      data-dtm="masthead"
                    >
                      {{aemContent?.manageCardButtontext1}}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                      >
                        <path
                          d="M14.2886 10.8765V15.1728C14.2886 15.8885 13.7064 16.4707 12.9906 16.4707H1.29612C0.580392 16.4707 -0.00183105 15.8885 -0.00183105 15.1728V3.47638C-0.00183105 2.76066 0.580392 2.17843 1.29612 2.17843H5.62385C6.03363 2.17843 6.36553 2.51034 6.36553 2.92012C6.36553 3.3299 6.03363 3.6618 5.62385 3.6618H1.48154V14.9855H12.8052V10.8747C12.8052 10.4649 13.1371 10.133 13.5469 10.133C13.9567 10.133 14.2886 10.4649 14.2886 10.8747V10.8765ZM15.9889 1.07888C15.987 1.06591 15.9833 1.05293 15.9796 1.03995C15.9722 1.00842 15.9629 0.978757 15.9518 0.94909C15.9463 0.93611 15.9425 0.924985 15.937 0.912006C15.9203 0.873067 15.8999 0.834129 15.8758 0.798899C15.8758 0.797045 15.8721 0.79519 15.8702 0.793336C15.848 0.75996 15.8202 0.728439 15.7924 0.698771C15.7831 0.6895 15.7757 0.682083 15.7664 0.672812C15.7423 0.650562 15.7182 0.630165 15.6922 0.611623C15.6811 0.604206 15.6718 0.59679 15.6607 0.589373C15.6292 0.568976 15.5958 0.550434 15.5624 0.535601C15.5569 0.533746 15.5513 0.530038 15.5457 0.528184H15.5439C15.5031 0.509642 15.4623 0.498516 15.4215 0.489245C15.4104 0.487391 15.3993 0.485537 15.3881 0.483683C15.3529 0.47812 15.3177 0.474412 15.2806 0.472557C15.2732 0.472557 15.2676 0.470703 15.2602 0.470703H9.49359C9.08381 0.470703 8.75191 0.802607 8.75191 1.21239C8.75191 1.62217 9.08381 1.95407 9.49359 1.95407H13.469L6.25057 9.17252C5.96132 9.46178 5.96132 9.9309 6.25057 10.222C6.3952 10.3666 6.58433 10.4389 6.77532 10.4389C6.9663 10.4389 7.15543 10.3666 7.30006 10.222L14.5185 3.00356V6.99568C14.5185 7.40546 14.8504 7.73736 15.2602 7.73736C15.67 7.73736 16.0019 7.40546 16.0019 6.99568V1.21239C16.0019 1.16603 15.9963 1.12153 15.9889 1.07888Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <div
                class="card-details-2 d-none d-md-block align-self-start ms-md-auto"
              >
                <div
                  class="total-points-label gb-headline5 heavy"
                  [innerHTML]="$safeNavigationMigration(aemContent?.totalPointsTitle2) | safeHtml"
                ></div>
                <div class="total-points-value gb-headline1 heavy">
                  {{totalEarnings | number:'1.0-0'}}
                </div>
                <div class="points-date gb-body1 heavy">
                  {{aemContent?.dateSubTitle1}}{{asOf}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Offer Section -->
      @if (showOfferSection) {
      <div class="offer-section">
        <div class="card">
          <div class="row align-items-start text-start">
            <div class="col-md-9">
              <div class="offer">
                <div class="offer-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="49"
                    viewBox="0 0 48 49"
                    fill="none"
                  >
                    <path
                      d="M47.8212 19.9261L43.6717 7.65112C43.1632 6.42271 42.1191 5.37629 40.8751 4.85763L28.5084 0.590063C27.101 0.262488 25.6573 0.617361 24.6222 1.54549L0.823994 25.3948C-0.274665 26.4958 -0.274665 28.1518 0.823994 29.2529L19.3196 47.6971C19.8281 48.2067 20.4727 48.4706 21.1991 48.4706C22.0072 48.4706 22.6519 48.2158 23.1785 47.6971L47.004 23.8206C47.912 22.6741 48.2298 21.2182 47.8303 19.9261H47.8212ZM45.524 22.5012L21.7258 46.2504C21.4806 46.496 21.0085 46.496 20.7633 46.2504L2.26769 27.8061C2.14965 27.6878 2.07701 27.5149 2.07701 27.3238C2.07701 27.1327 2.14965 26.9598 2.26769 26.8415L25.966 3.09237C26.3474 2.7102 26.8195 2.51911 27.3643 2.51911H27.891L40.1578 6.75029C40.8388 7.00507 41.5379 7.70572 41.7922 8.37906L45.9417 20.6449C46.1777 21.291 46.0234 22.0189 45.5421 22.5012H45.524ZM36.9163 8.54285C36.1082 8.54285 35.3455 8.86133 34.7826 9.43458C34.2196 10.0078 33.9018 10.7631 33.9018 11.5729C33.9018 12.3828 34.2196 13.1471 34.7826 13.7113C35.3546 14.2845 36.1082 14.5939 36.9163 14.5939C37.7244 14.5939 38.4871 14.2754 39.0501 13.7113C39.6221 13.138 39.9308 12.3828 39.9308 11.5729C39.9308 10.7631 39.613 9.99874 39.0501 9.43458C38.4871 8.87043 37.7244 8.54285 36.9163 8.54285ZM37.7789 12.4374C37.3431 12.8741 36.4896 12.8741 36.0537 12.4374C35.8358 12.219 35.7087 11.9096 35.7087 11.5729C35.7087 11.2362 35.8358 10.9269 36.0537 10.7085C36.2716 10.4901 36.5804 10.3627 36.9163 10.3627C37.2523 10.3627 37.561 10.4901 37.7789 10.7085C38.2329 11.1634 38.2329 11.9824 37.7789 12.4374ZM31.1052 19.553L29.825 20.836C30.3062 21.6367 30.5423 22.4466 30.506 23.2746C30.4787 24.0936 30.2699 24.8761 29.8704 25.6131L27.4097 24.3847C27.5913 23.9389 27.6549 23.4657 27.6095 22.9561C27.5641 22.4557 27.3189 21.9825 26.874 21.5367C26.4745 21.1363 26.0659 20.9088 25.6755 20.8542C25.276 20.8087 24.9219 20.9452 24.595 21.2637C24.3407 21.5185 24.2136 21.8278 24.2136 22.1827C24.2136 22.5376 24.2953 22.9288 24.4497 23.3656C24.6041 23.7933 24.7947 24.2482 25.0127 24.7305C25.2397 25.231 25.4576 25.7678 25.6573 26.332C25.8571 26.8961 25.9933 27.4785 26.0478 28.0791C26.1022 28.6796 26.0296 29.2893 25.8208 29.8989C25.6119 30.5086 25.2124 31.1182 24.6222 31.7097C24.0139 32.3193 23.3601 32.7379 22.6519 32.9472C21.9528 33.1565 21.2445 33.1929 20.5272 33.0564C19.819 32.9108 19.1471 32.6287 18.5206 32.1919L17.1677 33.5568L15.152 31.5459L16.5684 30.1264C16.0145 29.2165 15.7422 28.261 15.7422 27.2783C15.7422 26.2956 15.9782 25.322 16.4322 24.3665L18.9927 25.5585C18.7203 26.2683 18.6205 26.9689 18.6931 27.6787C18.7657 28.3793 19.0381 28.9708 19.5103 29.453C19.9915 29.9353 20.5 30.1992 21.0266 30.2447C21.5532 30.2811 22.0345 30.0809 22.4794 29.635C22.8063 29.3075 22.9788 28.9435 23.0151 28.5431C23.0514 28.1336 22.9879 27.6969 22.8335 27.2237C22.6791 26.7415 22.4885 26.241 22.2524 25.7132C22.0254 25.1855 21.8075 24.6486 21.6077 24.1027C21.408 23.5567 21.2808 23.0016 21.2264 22.4557C21.1628 21.9006 21.2264 21.3456 21.408 20.7996C21.5896 20.2446 21.9437 19.7077 22.4703 19.1708C23.1331 18.4975 23.9503 18.1153 24.9219 18.0061C25.8934 17.8969 26.8559 18.1699 27.8183 18.8251L29.0804 17.5512L31.0961 19.5621L31.1052 19.553Z"
                      fill="#33302B"
                    />
                  </svg>
                  <!--Mobile view -->
                  <div class="d-sm-block d-md-none gb-headline4 heavy">
                    {{aemContent?.offerTitle2}}
                  </div>
                </div>
                <div class="offer-content">
                  <div class="d-none d-md-block gb-headline4 heavy pb-12">
                    {{aemContent?.offerTitle2}}
                  </div>
                  <div class="gb-body1">{{aemContent?.offerSubTitle2}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-3 offer-btn">
              <button
                class="btn btn-outline-dark explore-more gb-headline6 heavy"
                (click)="navigateToRedeemPoint()"
              >
                {{aemContent?.learnMoreButtontext2}}
              </button>
            </div>
          </div>
        </div>
      </div>
      }
    </section>

    <!-- Points Usage Section && Redemption Options-->
    <section class="p-64-bottom p-48-bottom">
      <!-- Points Usage Section -->
      <div class="points-usage-section">
        <div
          class="text-center point-title gb-headline1 heavy"
          [innerHTML]="$safeNavigationMigration(aemContent?.promotionTitleText2) | safeHtml"
        ></div>
        <div
          class="text-center points-description gb-headline5"
          [innerHTML]="$safeNavigationMigration(aemContent?.subTitle7) | safeHtml"
        ></div>

        <!-- Redemption Options -->
        <div class="row redemption-options text-start">
          @for (option of redemptionOptions; track option.modalType) {
          <div class="col-md-4">
            <button
              (click)="openModal(option.modalType)"
              class="card redemption-card w-100 border-0 stat-image-link"
              data-dtm="your points"
            >
              <div class="card-img-container">
                <img
                  ngSrc="{{option?.image}}"
                  class="card-img-top"
                  [alt]="$safeNavigationMigration(option?.title)"
                  fill="true"
                  priority="true"
                />
                <div class="card-img-overlay">
                  <div class="vector-container">
                    @if (option.title === "Purchase or Lease an Eligible, New
                    Vehicle") {
                    <!--Black-->
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <path
                        d="M10.5 20.4707C4.977 20.4707 0.5 15.9937 0.5 10.4707C0.5 4.9477 4.977 0.470703 10.5 0.470703C16.023 0.470703 20.5 4.9477 20.5 10.4707C20.5 15.9937 16.023 20.4707 10.5 20.4707ZM10.5 18.4707C12.6217 18.4707 14.6566 17.6278 16.1569 16.1276C17.6571 14.6273 18.5 12.5924 18.5 10.4707C18.5 8.34897 17.6571 6.31414 16.1569 4.81385C14.6566 3.31356 12.6217 2.4707 10.5 2.4707C8.37827 2.4707 6.34344 3.31356 4.84315 4.81385C3.34285 6.31414 2.5 8.34897 2.5 10.4707C2.5 12.5924 3.34285 14.6273 4.84315 16.1276C6.34344 17.6278 8.37827 18.4707 10.5 18.4707ZM9.5 5.4707H11.5V7.4707H9.5V5.4707ZM9.5 9.4707H11.5V15.4707H9.5V9.4707Z"
                        fill="#3D3935"
                      />
                    </svg>
                    } @else {
                    <!-- White-->
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <path
                        d="M10.5 20.4706C4.977 20.4706 0.5 15.9936 0.5 10.4706C0.5 4.94758 4.977 0.470581 10.5 0.470581C16.023 0.470581 20.5 4.94758 20.5 10.4706C20.5 15.9936 16.023 20.4706 10.5 20.4706ZM10.5 18.4706C12.6217 18.4706 14.6566 17.6277 16.1569 16.1274C17.6571 14.6271 18.5 12.5923 18.5 10.4706C18.5 8.34885 17.6571 6.31402 16.1569 4.81373C14.6566 3.31344 12.6217 2.47058 10.5 2.47058C8.37827 2.47058 6.34344 3.31344 4.84315 4.81373C3.34285 6.31402 2.5 8.34885 2.5 10.4706C2.5 12.5923 3.34285 14.6271 4.84315 16.1274C6.34344 17.6277 8.37827 18.4706 10.5 18.4706ZM9.5 5.47058H11.5V7.47058H9.5V5.47058ZM9.5 9.47058H11.5V15.4706H9.5V9.47058Z"
                        fill="white"
                      />
                    </svg>
                    }
                  </div>
                  <div class="card-title gb-headline4">{{option?.title}}</div>
                </div>
              </div>
            </button>
          </div>
          }
        </div>

        <div class="text-center">
          <button
            (click)="navigateToRedeemPoint()"
            class="btn btn-outline-dark gb-headline6 heavy more-options stat-button-link"
            data-dtm="your points"
          >
            {{aemContent?.moreOptionsButtonText3}}
          </button>
        </div>
      </div>
    </section>

    <!-- Help Section -->
    <section class="p-64-bottom p-48-bottom">
      <div class="row help-section">
        <div class="col-md-6 card-help-section">
          <div class="card help-card">
            <div class="card-body text-center">
              <div class="title-text-help">
                {{aemContent?.locateADealerTitle4}}
              </div>
              <div class="sub-text-help gb-body1">
                {{aemContent?.locateADealerSubTitle5}}
              </div>
              <button
                (click)="openDealerLocator()"
                class="btn btn-style gb-headline6 heavy btn-outline-dark stat-button-link"
                data-dtm="quick links"
              >
                {{aemContent?.locateADealerButtonText4}}
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-6 card-help-section">
          <div class="card help-card">
            <div class="card-body text-center">
              <div class="title-text-help">{{aemContent?.faqTitle7}}</div>
              <div class="sub-text-help gb-body1">
                {{aemContent?.faqSubTitle6}}
              </div>
              <button
                (click)="openModal('faq')"
                class="btn btn-style gb-headline6 heavy btn-outline-dark stat-button-link"
                data-dtm="quick links"
              >
                {{aemContent?.faqButtonText5}}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                >
                  <path
                    d="M14.2886 10.8765V15.1728C14.2886 15.8885 13.7064 16.4707 12.9906 16.4707H1.29612C0.580392 16.4707 -0.00183105 15.8885 -0.00183105 15.1728V3.47638C-0.00183105 2.76066 0.580392 2.17843 1.29612 2.17843H5.62385C6.03363 2.17843 6.36553 2.51034 6.36553 2.92012C6.36553 3.3299 6.03363 3.6618 5.62385 3.6618H1.48154V14.9855H12.8052V10.8747C12.8052 10.4649 13.1371 10.133 13.5469 10.133C13.9567 10.133 14.2886 10.4649 14.2886 10.8747V10.8765ZM15.9889 1.07888C15.987 1.06591 15.9833 1.05293 15.9796 1.03995C15.9722 1.00842 15.9629 0.978757 15.9518 0.94909C15.9463 0.93611 15.9425 0.924985 15.937 0.912006C15.9203 0.873067 15.8999 0.834129 15.8758 0.798899C15.8758 0.797045 15.8721 0.79519 15.8702 0.793336C15.848 0.75996 15.8202 0.728439 15.7924 0.698771C15.7831 0.6895 15.7757 0.682083 15.7664 0.672812C15.7423 0.650562 15.7182 0.630165 15.6922 0.611623C15.6811 0.604206 15.6718 0.59679 15.6607 0.589373C15.6292 0.568976 15.5958 0.550434 15.5624 0.535601C15.5569 0.533746 15.5513 0.530038 15.5457 0.528184H15.5439C15.5031 0.509642 15.4623 0.498516 15.4215 0.489245C15.4104 0.487391 15.3993 0.485537 15.3881 0.483683C15.3529 0.47812 15.3177 0.474412 15.2806 0.472557C15.2732 0.472557 15.2676 0.470703 15.2602 0.470703H9.49359C9.08381 0.470703 8.75191 0.802607 8.75191 1.21239C8.75191 1.62217 9.08381 1.95407 9.49359 1.95407H13.469L6.25057 9.17252C5.96132 9.46178 5.96132 9.9309 6.25057 10.222C6.3952 10.3666 6.58433 10.4389 6.77532 10.4389C6.9663 10.4389 7.15543 10.3666 7.30006 10.222L14.5185 3.00356V6.99568C14.5185 7.40546 14.8504 7.73736 15.2602 7.73736C15.67 7.73736 16.0019 7.40546 16.0019 6.99568V1.21239C16.0019 1.16603 15.9963 1.12153 15.9889 1.07888Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<app-modal
  *ngIf="modalDesign === 'default'"
  [visible]="modalVisible"
  [title]="$safeNavigationMigration(currentModalConfig?.title)"
  [showHeader]="false"
  [showFooter]="false"
  [modalSize]="'modal-lg'"
  (visibleChange)="closeModal()"
>
  <div class="d-flex flex-column modal-gap">
    <div id="modal-bod">
      <div class="gb-headline1 heavy">{{currentModalConfig?.title}}</div>
    </div>
    <div class="gb-body1">
      <div class="label gb-headline6">{{currentModalConfig?.content}}</div>
    </div>
    <div>
      <button
        (click)="executeModalAction(true)"
        class="btn btn-style btn-outline-dark stat-button-link"
        data-dtm="modal:leaving gmcard"
      >
        {{ currentModalConfig?.primaryButtonText }}
      </button>
    </div>
  </div>
</app-modal>
<app-modal
  *ngIf="modalDesign === 'alternate'"
  [visible]="modalVisible"
  [title]="$safeNavigationMigration(currentModalConfig?.title)"
  [showHeader]="false"
  [showFooter]="false"
  [modalSize]="'modal-lg'"
  (visibleChange)="closeModal()"
>
  <div class="d-flex flex-column modal-gap">
    <div id="modal-body">
      <div class="gb-headline4 heavy">{{currentModalConfig?.title}}</div>
    </div>
    <div class="gb-body1">
      <div
        class="gb-headline6 pb-12"
        [innerHTML]="$safeNavigationMigration(currentModalConfig?.content) | safeHtml"
      ></div>
      <div class="subLabel gb-disclaimer">
        {{currentModalConfig?.subContent}}
      </div>
    </div>
  </div>
</app-modal>
